import { render, staticRenderFns } from "./permissionPopup.vue?vue&type=template&id=9851894c&scoped=true&"
import script from "./permissionPopup.vue?vue&type=script&lang=js&"
export * from "./permissionPopup.vue?vue&type=script&lang=js&"
import style0 from "./permissionPopup.vue?vue&type=style&index=0&id=9851894c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9851894c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ganttpro/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9851894c')) {
      api.createRecord('9851894c', component.options)
    } else {
      api.reload('9851894c', component.options)
    }
    module.hot.accept("./permissionPopup.vue?vue&type=template&id=9851894c&scoped=true&", function () {
      api.rerender('9851894c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/views/profileSettings/include/permissionPopup.vue"
export default component.exports